import AssignToContainer from './assign-to-container';

export default AssignToContainer;
